import { ChangeEvent,useState } from "react";

interface TextUploaderProps {
  text: string;
  setText: (text : string) => void;
}

export default function TextUploader({ text, setText}: TextUploaderProps){

    return(
        <div>
            <textarea className="textarea-primary" placeholder="Füge hier Inhalte ein..." value={text} onChange={(e) => setText(e.target.value)} />
        </div>
        
    );
}